import React, { memo, forwardRef, useMemo, useImperativeHandle, useRef } from 'react';
import { Mesh, DoubleSide, Vector3, Color } from 'three';
import { seatGeometry, seatMaterial } from '../SharedMeshes/SharedMeshes';
import { ThreeEvent } from '@react-three/fiber';

export interface SeatProps {
  position: Vector3;
  onClick: (event?: ThreeEvent<PointerEvent>) => void;
  seatedUserId?: string;
}

const Seat = memo<SeatProps>(({ position, onClick, seatedUserId = '' }) => {
  // console.log('seat rendered', position.x.toFixed(1), position.z.toFixed(1), seatedUserId);

  return (
    <>
      {seatedUserId === '' && (
        <mesh position={position} onPointerDown={onClick} rotation-x={Math.PI / 2}>
          {seatGeometry}
          {seatMaterial}
        </mesh>
      )}
    </>
  );
}, areSeatsEqual);

export default Seat;

function areSeatsEqual(prevProps: SeatProps, nextProps: SeatProps) {
  return (
    prevProps.position.equals(nextProps.position)
    && prevProps.seatedUserId === nextProps.seatedUserId
  );
}
